export const renderThumbnail = async (
  asepriteResource: any,
  frameIndex: number = 0
) => {
  const {
    graphic: { sourceView: frameSource, image },
  } = asepriteResource.frames[frameIndex];

  const img: HTMLImageElement = await new Promise((resolve, reject) => {
    const img = new Image();
    img.src = image.path;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });

  const tempCanvas = Object.assign(document.createElement("canvas"), {
    width: frameSource.width,
    height: frameSource.height,
  });

  tempCanvas
    .getContext("2d")!
    .drawImage(
      img,
      frameSource.x,
      frameSource.y,
      frameSource.width,
      frameSource.height,
      0,
      0,
      frameSource.width,
      frameSource.height
    );

  return tempCanvas.toDataURL();
};

export const renderLook = async (
  asepriteResource: any,
  frameIndex: number = 0
) => {
  const {
    graphic: { sourceView: frameSource, image },
  } = asepriteResource.frames[frameIndex];

  const img: HTMLImageElement = await new Promise((resolve, reject) => {
    const img = new Image();
    img.src = image.path;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });

  const tempCanvas = Object.assign(document.createElement("canvas"), {
    width: frameSource.width,
    height: frameSource.height,
  });

  tempCanvas
    .getContext("2d")!
    .drawImage(
      img,
      frameSource.x,
      frameSource.y,
      frameSource.width,
      frameSource.height,
      0,
      0,
      frameSource.width,
      frameSource.height
    );

  return tempCanvas.toDataURL();
};
